import React, { useMemo, useState } from "react"
import ExportExcel from "components/Excelconvert/ExportExcel"

import { useSelector, useDispatch } from "react-redux"
import {
    CardBody,
    Card,
    Col,
    CardTitle,
    Badge,
    Modal,
    UncontrolledTooltip,
    Button,
    Form,
    Input,
    Label,
    Row,
    FormFeedback,
    Container,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

//Validation
import * as Yup from "yup"
import { useFormik, Field } from "formik"

import moment from "moment"

//import components
import TableContainer from "components/Common/TableContainer"
import { useEffect } from "react"

import BarcodeReader from 'react-barcode-reader'
// import BarcodeScannerComponent from "react-webcam-barcode-scanner";

// slice
import {
    TicketBookedHistory,
    resetVenue,
    scanningData,
    resetScannedData,
    getScannedList
} from "toolkitStore/eventMSlice/VenueSlice"

function GateScanning(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const event_id_c = JSON.parse(localStorage.getItem("event_id"))
    // console.log("event_id", event_id_c)
    const venue_id_c = JSON.parse(localStorage.getItem("venue_id"))
    // console.log("venue_id", venue_id_c)

    const { TicketBookedDetails, VenueisSuccessfully, scannedUser, scannedList ,scannedUserStatus, scannerStatusMessage } = useSelector(
        state => state.VenueReducer
    )

    const [scannedData, setScandata] = useState('')
    const [data, setData] = React.useState('Not Found');
    const [barValue, setBarValue] = useState('')

    useEffect(() => {
        dispatch(TicketBookedHistory(venue_id_c.VenueId))
            dispatch(getScannedList(venue_id_c.VenueId))
        
        dispatch(resetScannedData())
        dispatch(resetVenue())


      }, [dispatch, venue_id_c.VenueId])
    useEffect(() => {
        console.log("scannedUser", scannedUser, scannedUserStatus)
    }, [scannedUser, scannedUserStatus])
 

 

   const columns = useMemo(() => [
  {
    Header: "Name",
    accessor: "firstname",
    Cell: ({ row }) => (
      <div>
        {row.original.firstname} {row.original.lastname}
      </div>
    )
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Member Adult",
    accessor: "adult_member_count",
  },
  {
    Header: "Member Child",
    accessor: "child_member_count",
  },
  {
    Header: "Non-Member Adult",
    accessor: "adult_non_member_count",
  },
  {
    Header: "Non-Member Child",
    accessor: "child_non_member_count",
  },
  {
    Header: "Veg",
    accessor: "veg_adult_count",
  },
  {
    Header: "Non-Veg",
    accessor: "nonveg_adult_count",
  },
  {
    Header: "Scanned At",
    accessor: "createdAt",
    Cell: ({ row }) => (
      <div>
        {moment(row.original.createdAt).format("DD/MM/YYYY HH:mm")}
      </div>
    )
  }
], [])

    const handleScan = (data) => {
        setScandata(data)
    }
    const handleError = (err) => {
        console.error(err)
    }

    const storeScannedData = () => {

    }
  useEffect(() => {
    if (scannedUserStatus) {
      dispatch(getScannedList(venue_id_c.VenueId))
    }
  }, [scannedUserStatus, dispatch, venue_id_c.VenueId])

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            scan_data: ""
        },
        validationSchema: Yup.object({
            scan_data: Yup.string().required(
                "Scan barcode"
            ),

        }),
         onSubmit: (values, actions) => {
              dispatch(resetScannedData())
        
              let barcodeValue = values.scan_data
        
              if (Array.isArray(barcodeValue)) {
                barcodeValue = barcodeValue.join("")
              }
        
              dispatch(
                scanningData({
                  barcode: barcodeValue,
                })
              )
        
              actions.resetForm()
            },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Utility" breadcrumbItem="Booked Information" />

                    <Row className="">
                        <Card>
                            <CardBody className="border-botton" style={{ minHeight: 570 }}>
                                <div className="d-flex align-items-center">
                                    <h5 className="mb-1 card-title flex-grow-1 text-primary">
                                        {event_id_c.EventName + " / " + venue_id_c.VenueName}
                                    </h5>
                                    <div className="mb-1 flex-shrink-0">

                                        {/* <ExportExcel
                                            excelData={TicketBookedDetails}
                                            fileName={`Booking Details ${venue_id_c.VenueName}`}
                                        /> */}

                                        <Link to="/eventvenues" className="btn btn-secondary me-1">
                                            Back
                                        </Link>
                                        <Link
                                            to="#!"
                                            onClick={() => {
                                                /*  dispatch(fetchServices(userInformation.m_company_id)) */
                                            }}
                                            className="btn btn-light me-1"
                                        >
                                            <i className="mdi mdi-refresh"></i>
                                        </Link>
                                    </div>
                                </div>
                                <Row>
                                    <div className="col-6">
                                        <div>
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault()
                                                    validation.handleSubmit()
                                                    // storeScannedData()
                                                }}
                                            >
                                                <Label htmlFor="scan_data">
                                                    Barcode data
                                                </Label>
                                                <Input
                                                    name="scan_data"
                                                    className="form-control "
                                                    type="text"
                                                    autoFocus
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.scan_data || ""}
                                                    invalid={
                                                        validation.touched.scan_data &&
                                                            validation.errors.scan_data
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validation.touched.scan_data &&
                                                    validation.errors.scan_data ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.scan_data}
                                                    </FormFeedback>
                                                ) : null}
                                                {/* <button
                                                    className="btn btn-primary mt-3"
                                                    type="submit"

                                                >Submit</button> */}
                                            </Form>
                                        </div>
                                        {/* <BarcodeReader
                                            onError={handleError}
                                            onScan={handleScan}
                                        /> */}
                                        <p>{scannedData}</p>
                                    </div>
                                </Row>
                                <Row>
                                    {/* {
                                        scannedUserStatus && scannedUserStatus === "2" ?
                                            <div style={{ fontSize: 30, fontWeight: "bold", color: "red" }}>{scannerStatusMessage}</div>
                                            : scannedUserStatus && scannedUserStatus === "3" ?
                                                <div className="col-10">
                                                    <div>
                                                        <div>Name : <br /><span style={{ fontSize: 40 }}>{scannedUser.firstname} {scannedUser.lastname}</span></div>
                                                        <div style={{ fontSize: 20 }}>Adult : {scannedUser.adult_count}, Child : {scannedUser.child_count}</div>
                                                        <div>Email : {scannedUser.email}</div>
                                                        <div style={{ fontSize: 30, fontWeight: "bold", color: "red" }}>{scannerStatusMessage}</div>
                                                    </div>
                                                </div>
                                                : scannedUserStatus && scannedUserStatus === "1" ?
                                                    <div className="col-10">
                                                        <div>
                                                            <div>Name : <br /><span style={{ fontSize: 40 }}>{scannedUser.firstname} {scannedUser.lastname}</span></div>
                                                            <div style={{ fontSize: 20 }}>Adult : {scannedUser.adult_count}, Child : {scannedUser.child_count}</div>
                                                            <div>Email : {scannedUser.email}</div>
                                                            <div style={{ fontSize: 30, fontWeight: "bold", color: "green" }}>{scannerStatusMessage}</div>
                                                        </div>
                                                    </div>
                                                    :
                                                    null

                                    } */}

                                    {scannedUser && (
  <div className="col-10">
    <div style={{ padding: 20, borderRadius: 10, background: "#f8f9fa" }}>

      <h2>
        {scannedUser?.firstname} {scannedUser?.lastname}
      </h2>

      <p><b>Email:</b> {scannedUser?.email}</p>

      <hr />

      <h4>👥 Entry Tickets</h4>
      <p>
        Member → Adult: {scannedUser?.adult_member_count || 0}, 
        Child: {scannedUser?.child_member_count || 0}
      </p>
      <p>
        Non-Member → Adult: {scannedUser?.adult_non_member_count || 0}, 
        Child: {scannedUser?.child_non_member_count || 0}
      </p>

      <hr />

      <h4>🍽 Food</h4>
      <p>
        Veg → Adult: {scannedUser?.veg_adult_count || 0}, 
        Child: {scannedUser?.veg_child_count || 0}
      </p>

      <p>
        Non-Veg → Adult: {scannedUser?.nonveg_adult_count || 0}, 
        Child: {scannedUser?.nonveg_child_count || 0}
      </p>

      <p>
        Vegan (Member) → Adult: {scannedUser?.vegan_adult_member_count || 0}, 
        Child: {scannedUser?.vegan_child_member_count || 0}
      </p>

      <p>
        Vegan (Non-Member) → Adult: {scannedUser?.vegan_adult_non_member_count || 0}, 
        Child: {scannedUser?.vegan_child_non_member_count || 0}
      </p>

      <hr />

      <div
        style={{
          fontSize: 30,
          fontWeight: "bold",
          color:
            scannedUserStatus === "1"
              ? "green"
              : scannedUserStatus === "3"
              ? "orange"
              : "red",
        }}
      >
        {scannerStatusMessage}
      </div>

    </div>
  </div>
)}
                                </Row>
                                {/* <Row>
                                    <div className="container-fluid">
                                        <TableContainer
                                            columns={columns}
                                            data={TicketBookedDetails}
                                            isGlobalFilter={true}
                                            isAddOptions={false}
                                            customPageSize={30}
                                            isJobListGlobalFilter={false}
                                        // className="custom-header-css"
                                        />
                                    </div>
                                </Row>
                                {TicketBookedDetails.length > 30 ? (
                                    <Row>
                                        <Col xs="12">
                                            <div className="text-center my-3">
                                                <Link to="#" className="text-success">
                                                    <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                                                    Load more
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                ) : null} */}
 {scannedList?.length > 0 && (
                 <Row className="mt-4">
                   <Col xl="12">
                     <Card>
                       <CardBody>
                         <h4>Scanned Users ({scannedList.length})</h4>
 
                         <TableContainer
                           key={scannedList.length}
                           columns={columns}
                           data={scannedList}
                           isGlobalFilter={true}
                           customPageSize={10}
                         />
                       </CardBody>
                     </Card>
                   </Col>
                 </Row>
               )}
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default GateScanning
